(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const offsetWhatsAppButton = () => {
      const widget = document.querySelector('gty-whatsapp-chat-button');
      const shadowRoot = widget?.shadowRoot;

      if (!shadowRoot) return false;

      let offsetStyle = shadowRoot.querySelector('[data-mobile-sticky-whatsapp-offset]');

      if (!offsetStyle) {
        offsetStyle = document.createElement('style');
        offsetStyle.setAttribute('data-mobile-sticky-whatsapp-offset', '');
        shadowRoot.appendChild(offsetStyle);
      }

      offsetStyle.textContent = `
        @media screen and (max-width: 749px) {
          .gty-wacb-wrapper {
            bottom: calc(13.8rem + env(safe-area-inset-bottom)) !important;
          }
        }
      `;

      return true;
    };

    const initialize = (root) => {
      if (root.dataset.mobileStickyInitialized === 'true') return;
      root.dataset.mobileStickyInitialized = 'true';

      const formId = root.dataset.productFormId;
      const sectionId = root.dataset.sectionId;
      const stickyButton = root.querySelector('[data-mobile-sticky-submit]');
      const stickyLabel = root.querySelector('[data-mobile-sticky-label]');
      const stickySelect = root.querySelector('[data-mobile-sticky-variant-select]');
      const stickyPrice = root.querySelector('[data-mobile-sticky-price]');
      const stickyComparePrice = root.querySelector('[data-mobile-sticky-compare-price]');
      const stickyQuantity = root.querySelector('[data-mobile-sticky-quantity]');
      const minusButton = root.querySelector('[data-mobile-sticky-quantity-minus]');
      const plusButton = root.querySelector('[data-mobile-sticky-quantity-plus]');
      const productInfo = document.getElementById(`ProductInfo-${sectionId}`);

      const getProductForm = () => document.getElementById(formId);
      const getOriginalButton = () => getProductForm()?.querySelector('.product-form__submit');

      const getQuantityInput = () => {
        const form = getProductForm();
        if (!form) return null;

        let quantityInput = form.querySelector('[name="quantity"]');

        if (!quantityInput) {
          quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'quantity';
          quantityInput.value = stickyQuantity.value;
          form.appendChild(quantityInput);
        }

        return quantityInput;
      };

      const setQuantity = (nextValue) => {
        const quantityInput = getQuantityInput();
        const minimum = Number(quantityInput?.min || stickyQuantity.min || 1);
        const maximum = Number(quantityInput?.max || Number.MAX_SAFE_INTEGER);
        const nextQuantity = Math.min(maximum, Math.max(minimum, Number(nextValue) || minimum));

        stickyQuantity.value = String(nextQuantity);

        if (quantityInput) {
          quantityInput.value = String(nextQuantity);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const sync = () => {
        const form = getProductForm();
        const originalButton = getOriginalButton();
        const variantId = form?.querySelector('[name="id"]')?.value;
        const priceContainer = document.getElementById(`price-${sectionId}`);
        const currentPrice =
          priceContainer?.querySelector('.price__sale .price-item--sale') ||
          priceContainer?.querySelector('.price__regular .price-item--regular');
        const comparePrice = priceContainer?.querySelector('.price__sale .price-item--regular');
        const quantityInput = getQuantityInput();

        if (stickySelect && variantId && stickySelect.querySelector(`option[value="${variantId}"]`)) {
          stickySelect.value = variantId;
        }

        if (currentPrice?.textContent.trim()) {
          stickyPrice.textContent = currentPrice.textContent.trim();
        }

        if (comparePrice?.textContent.trim()) {
          stickyComparePrice.textContent = comparePrice.textContent.trim();
          stickyComparePrice.hidden = false;
        } else {
          stickyComparePrice.hidden = true;
        }

        if (quantityInput) {
          stickyQuantity.min = quantityInput.min || '1';
          stickyQuantity.max = quantityInput.max || '';
          stickyQuantity.step = quantityInput.step || '1';
          stickyQuantity.value = quantityInput.value || stickyQuantity.min;
        }

        if (originalButton) {
          stickyButton.disabled = originalButton.disabled;
          const originalLabel = originalButton.querySelector('span')?.textContent.trim();
          if (originalLabel) stickyLabel.textContent = originalLabel;
        }
      };

      if (stickySelect) {
        stickySelect.addEventListener('change', () => {
          const selectedOption = stickySelect.selectedOptions[0];
          const variantPicker = productInfo?.querySelector('variant-selects');
          const originalSelects = variantPicker ? Array.from(variantPicker.querySelectorAll('select')) : [];
          let variantOptions = [];

          try {
            variantOptions = JSON.parse(selectedOption.dataset.variantOptions || '[]');
          } catch (error) {
            variantOptions = [];
          }

          originalSelects.forEach((select, index) => {
            if (variantOptions[index]) select.value = variantOptions[index];
          });

          const changeTarget = originalSelects[originalSelects.length - 1];
          changeTarget?.dispatchEvent(new Event('change', { bubbles: true }));
          window.setTimeout(sync, 350);
        });
      }

      stickyQuantity.addEventListener('change', () => setQuantity(stickyQuantity.value));
      minusButton.addEventListener('click', () => {
        setQuantity(Number(stickyQuantity.value) - Number(stickyQuantity.step || 1));
      });
      plusButton.addEventListener('click', () => {
        setQuantity(Number(stickyQuantity.value) + Number(stickyQuantity.step || 1));
      });

      stickyButton.addEventListener('click', () => {
        const originalButton = getOriginalButton();
        if (originalButton && !originalButton.disabled) originalButton.click();
      });

      productInfo?.addEventListener('change', () => {
        window.setTimeout(sync, 0);
        window.setTimeout(sync, 350);
      });

      if (productInfo) {
        new MutationObserver(sync).observe(productInfo, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled', 'value'],
        });
      }

      document.body.classList.add('mobile-sticky-purchase-active');
      sync();
    };

    document.querySelectorAll('[data-mobile-sticky-purchase]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-mobile-sticky-purchase]').forEach(initialize);
    });

    offsetWhatsAppButton();
    customElements.whenDefined('gty-whatsapp-chat-button').then(() => {
      offsetWhatsAppButton();
      window.setTimeout(offsetWhatsAppButton, 500);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
